<template>
	<gc-dialog
		:title="type === 'cmd' ? '指令详情' : '通讯记录详情'"
		:show.sync="visible"
		:append-to-body="true"
		width="1080px"
		:showOkBtn="false"
		:showCancelBtn="false"
		@cancel="$emit('close-modal')"
		@close="$emit('close-modal')"
	>
		<div class="content">
			<gc-table
				v-if="type === 'cmd'"
				:showPage="false"
				:columns="columns"
				:table-data="tableData"
				:border="true"
			></gc-table>
			<div v-if="type === 'communicate'" class="communicate-details">
				<div class="communicate-modal" v-for="(item, index) in tableData" :key="index">
					<div class="modal-title">{{ item.name }}</div>
					<template v-if="item.type === 'column'">
						<div class="list-details">
							<div class="list-details-item" v-for="(itemName, idx) in item.dataList" :key="idx">
								<div class="detail-label">{{ itemName.label }}</div>
								<div class="detail-value">
									<p :title="itemName.value">{{ itemName.value }}</p>
								</div>
							</div>
						</div>
					</template>
					<template v-if="item.type === 'table'">
						<gc-table
							:showPage="false"
							:columns="item.columns"
							:table-data="item.dataList"
							border
							isStripe
						></gc-table>
					</template>
				</div>
			</div>
		</div>
	</gc-dialog>
</template>

<script>
export default {
	props: {
		tableData: {
			type: Array,
			default: () => [],
		},
		type: {
			type: String,
			default: 'communicate',
		},
	},
	data() {
		return {
			visible: true,
			columns: [
				{
					key: 'key',
					name: '字段名称',
					width: 220,
				},
				{
					key: 'value',
					name: '字段数值',
					render: (h, row) => {
						if (row.key !== '状态字信息') return h('span', null, row.value)
						const items = row.value.map(item => {
							return h('li', { key: item.key, style: { lineHeight: '28px' } }, [
								h('span', { style: { color: '#999' } }, item.key + '：'),
								h('span', { style: { color: '#333' } }, item.value),
							])
						})
						return h('ul', null, items)
					},
				},
			],
		}
	},
}
</script>

<style scoped lang="scss">
.communicate-details {
	border-radius: 6px;
	max-height: 580px;
	.communicate-modal {
		padding: 16px 20px;
		.modal-title {
			font-size: 16px;
			color: #4d6bff;
		}
		.list-details {
			margin-top: 6px;
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
			gap: 8px;
			.list-details-item {
				.detail-label {
					color: #999;
					padding: 6px 0;
				}
				.detail-value {
					color: #4c4c4c;
					padding: 4px 0;
					p {
						max-width: 100%;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						word-break: break-all;
					}
				}
			}
		}

		::v-deep .gc-table {
			margin-top: 12px;
		}
	}
}
</style>
